module.exports = __webpack_public_path__ + "img/AI (5).5db45cbd.png";